const fetchInitialDataResponse = ({
  data: {
    blocks,
    chapterTitle,
    chapterTitleIsEdited,
    chapterTitleLocales,
    courseLanguage,
    isDraft,
    order,
    publishDate,
    success,
    updatedAt
  }
}) => {
  if (!success) return { editorHeaderStatus: 'error', editorIsFetching: false };

  return {
    editorAdders: [false, ...order.map(() => false)],
    editorBlocks: blocks,
    editorBlocksOrder: order,
    editorCourseLanguage: courseLanguage,
    editorChapterTitle: chapterTitle,
    editorChapterTitleIsEdited: chapterTitleIsEdited,
    editorChapterTitleLocales: chapterTitleLocales,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsConnecting: false,
    editorIsDisabled: false,
    editorIsDraft: isDraft,
    editorIsFetching: false,
    editorPreviewVersionCourseLanguage: undefined,
    editorPreviewVersionCourseLanguageVersions: undefined,
    editorPublishDate: publishDate,
    editorTranslationReferenceLanguage: courseLanguage
  };
};

export default fetchInitialDataResponse;
